// React
import React from 'react';

// Components
import Wrapper from '../../listing/Wrapper/Wrapper';

// Contexts
import { ListingContext } from '../../../contexts/listing';

// Hooks
import useListing from '../../../hooks/useListing';

// Data types
import { trimCore, trimListing } from '../../../data-types/trim';

// This component
export default function Trims() {
  // Data types
  const { endpoint } = trimCore();
  const {
    initialSort,
    initialFilters,
    getColumns,
    getRows,
    getFilters
  } = trimListing();

  // Listing
  const {
    activeFilters,
    saveActiveFilters,
    page,
    pageSize,
    setPage,
    setPageSize,
    sortModel,
    setSortModel,
    resetSortModel,
    refreshDataGrid,
    setRefreshDataGrid
  } = useListing(initialSort, initialFilters, endpoint);

  // JSX
  return (
    <ListingContext.Provider
      value={{
        typeOfData: 'data-type',
        // Static
        initialFilters,
        endpoint,
        pageSize,
        getColumns,
        getRows,
        getFilters,
        // Dynamic
        activeFilters,
        saveActiveFilters,
        page,
        setPage,
        setPageSize,
        sortModel,
        setSortModel,
        resetSortModel,
        refreshDataGrid,
        setRefreshDataGrid
      }}>
      <Wrapper
        title="Available Vehicles"
        buttonNewLabel="New Vehicle"
        buttonNewUrl="/vehicle/new"
        exportAction={true}
        buttonExportLabel="Export Data"
      />
    </ListingContext.Provider>
  );
}
